import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import Group from 'components/utils/Group'
import React from 'react'
import LoyaltyTierBadge from './LoyaltyTierBadge'

function LoyaltyLandingPageTierInformation() {
  return (
    <Group direction="vertical" tabletDirection="horizontal" gap={48} tabletGap={36}>
      <VerticalSpacer gap={16}>
        <LoyaltyTierBadge size="large" tier="bronze" />
        <VerticalSpacer gap={4}>
          <Heading variant="heading5">
            Your journey starts here
          </Heading>
          <BodyText variant="medium">
            Start earning points and status credits from your very first booking.
          </BodyText>
        </VerticalSpacer>
      </VerticalSpacer>
      <VerticalSpacer gap={16}>
        <LoyaltyTierBadge size="large" tier="silver" />
        <VerticalSpacer gap={4}>
          <Heading variant="heading5">
            Step up the benefits
          </Heading>
          <BodyText variant="medium">
            Access added perks like lounge passes, tour credits, and discounted photoshoots.
          </BodyText>
        </VerticalSpacer>
      </VerticalSpacer>
      <VerticalSpacer gap={16}>
        <LoyaltyTierBadge size="large" tier="gold" />
        <VerticalSpacer gap={4}>
          <Heading variant="heading5">
            A new gold standard
          </Heading>
          <BodyText variant="medium">
            Enjoy elevated benefits including free room upgrades and chauffeur airport transfers.
          </BodyText>
        </VerticalSpacer>
      </VerticalSpacer>
      <VerticalSpacer gap={16}>
        <LoyaltyTierBadge size="large" tier="platinum" />
        <VerticalSpacer gap={4}>
          <Heading variant="heading5">
            The complete VIP experience
          </Heading>
          <BodyText variant="medium">
            Indulge in unlimited chauffeur transfers, additional room upgrades for the ultimate escape.
          </BodyText>
        </VerticalSpacer>
      </VerticalSpacer>
    </Group>
  )
}

export default LoyaltyLandingPageTierInformation
